import React from 'react';


function Header(){
    return (
        <div className='p-5 bg-primary flex justify-between header' >
            <h1 className='text-secondary text-4xl font-semibold headings'>A</h1>
            <h1 className='text-white text-4xl font-semibold headings'>K</h1>
            <h1 className='text-tertiary text-4xl font-semibold headings'>R</h1>
        </div>
    )
}

export default Header;
